import react from "react";

const Footer = () => {
    return (
        <footer>
            &copy; 2025 SamyFromTheDoc
        </footer>
    )
}

export default Footer;